module.exports = __webpack_public_path__ + "static/media/train-card6.581104ca.jpg";